export { LocationTab } from "./LocationTab";
export { FilesTab } from "./FilesTab";
export { UsersTab } from "./UsersTab";
export { SupervisorsTab } from "./SupervisorsTab";
export { InfoTab } from "./InfoTab";
